module.exports = __webpack_public_path__ + "img/logo-v.1517f303.png";